export default "__VITE_ASSET__Bo1nN8lc__"